import PageSectionHeader from '@ui/PageSectionHeader';
import { cn } from '@util/index';

interface HomeSectionProps {
  title?: string;
  href?: string;
  target?: string;
  linkText?: string;
  children: React.ReactNode;
  className?: string;
  subtitle?: string;
  fullWidth?: boolean;
  backgroundColor?: string;
  titleClassName?: string;
  linkClassName?: string;
  subtitleClassName?: string;
  seeAllPosition?: 'subtitle' | 'title';
  carouselWrapper?: boolean;
}

export default function HomeSection({
  title,
  href,
  target,
  linkText,
  children,
  className,
  subtitle,
  titleClassName,
  subtitleClassName,
  fullWidth = false,
  backgroundColor,
  seeAllPosition = 'subtitle',
  carouselWrapper = false,
  linkClassName,
}: HomeSectionProps) {
  const content = (
    <>
      {title && (
        <PageSectionHeader
          title={title}
          href={href}
          target={target}
          linkText={linkText}
          subtitle={subtitle}
          titleClassName={titleClassName}
          subtitleClassName={subtitleClassName}
          seeAllPosition={seeAllPosition}
          linkClassName={linkClassName}
        />
      )}

      <div className="h-full pt-[2rem]">
        {carouselWrapper ? (
          <div className="-mt-12 pl-4 sm:pl-0">{children}</div>
        ) : (
          children
        )}
      </div>
    </>
  );

  if (fullWidth) {
    return (
      <div
        className={cn('w-full', backgroundColor)}
        style={
          backgroundColor && !backgroundColor.startsWith('bg-')
            ? { backgroundColor }
            : undefined
        }
      >
        <div
          className={cn(
            'mx-auto flex w-full max-w-[150rem] flex-col px-8',
            className,
            'overflow-visible'
          )}
        >
          {content}
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex w-full flex-col overflow-visible sm:mx-auto sm:max-w-[150rem]',
        className
      )}
    >
      {content}
    </div>
  );
}
